export default __webpack_public_path__ + "static/media/normal-screen.2a405773.svg";